import { queryRequest } from "@/utils/request";
import { storeInfoDomain, getStoreInfo } from "@/graphql/store.gql";
import { AppPlatformEnums, ThemeNameEnums } from "@/enums/app";

/**
 * 获取app平台
 * JA, JT, TBR
 * 佳安，佳通，大胎
 */
export const getPlatform: any = () => {
  if (getPlatform.promise) return getPlatform.promise;

  const promise = new Promise(async resolve => {
    try {
      let data = await queryRequest({
        query: getStoreInfo
      });
      // const platformMap = {
      //   BR200619000083: AppPlatformEnums.JT,
      //   BR210204001653: AppPlatformEnums.JA
      // };
      // console.log(platformMap[data.brandCode]);
      // resolve(platformMap[data.brandCode]);

      // const platformMap = {
      //   佳通: AppPlatformEnums.JT,
      //   佳安: AppPlatformEnums.JA
      // };
      // console.log({
      //   platform: platformMap[data?.brand]
      // });
      resolve({
        platform: "TBR", // platformMap[data?.brand]
        storeTag: data?.storeTag || [],
        storeInfo: data
      });
    } catch (e) {
      console.error(e);
      resolve("");
    }
  });

  return (getPlatform.promise = promise);
};

/**
 * 渐变颜色主题
 */
export const ThemeGradientColorMap = {
  [AppPlatformEnums.TBR]: ["#FFD700", "#FFCA00"]
};

/**
 * 颜色主题
 */
export const ThemeColorMap = {
  [AppPlatformEnums.TBR]: {
    themeColor: "#FFCF00",
    textColor: "rgba(0, 0, 0, 0.87)",
    bgColor1: "#FFFAE7",
    bgColor2: "#FFF1B5"
  }
};

/**
 * 设置主题  默认佳通黄色主题
 * @param platform
 */
export const setPlatformTheme = (platform: string = AppPlatformEnums.TBR) => {
  // 添加主题样式

  (document.body as any)?.classList?.add(ThemeNameEnums[platform]);
  // 添加css变量
  document.documentElement.style.setProperty(
    "--theme-color--",
    getThemeBgColor(platform)
  );
  document.documentElement.style.setProperty(
    "--theme-text-color--",
    getThemeTextColor(platform)
  );
  document.documentElement.style.setProperty(
    "--theme-bg-color-1--",
    getThemeBgColor1(platform)
  );
  document.documentElement.style.setProperty(
    "--theme-bg-color-2--",
    getThemeBgColor2(platform)
  );
  // 设置渐变颜色
  document.documentElement.style.setProperty(
    "--theme-gradient-color-1--",
    ThemeGradientColorMap[platform] && ThemeGradientColorMap[platform][0]
  );
  document.documentElement.style.setProperty(
    "--theme-gradient-color-2--",
    ThemeGradientColorMap[platform] && ThemeGradientColorMap[platform][1]
  );
  document.documentElement.style.setProperty(
    "--theme-gradient-color--",
    getThemeGradientBgColor(platform)
  );
};

/**
 * 获取字体颜色
 * @param platform
 */
export const getThemeTextColor = (platform: string = AppPlatformEnums.TBR) => {
  return ThemeColorMap[platform]?.textColor;
};
/**
 * 获取背景色
 * @param platform
 */
export const getThemeBgColor = (platform: string = AppPlatformEnums.TBR) => {
  return ThemeColorMap[platform]?.themeColor;
};
/**
 * 获取背景色2
 * @param platform
 */
export const getThemeBgColor2 = (platform: string = AppPlatformEnums.TBR) => {
  return ThemeColorMap[platform]?.bgColor2;
};
/**
 * 获取背景色1
 * @param platform
 */
export const getThemeBgColor1 = (platform: string = AppPlatformEnums.TBR) => {
  return ThemeColorMap[platform]?.bgColor1;
};

/**
 * 获取渐变背景色，e.g. linear-gradient(to right, #FFD700 , #FFCA00)
 * @param platform
 */
export const getThemeGradientBgColor = (
  platform: string = AppPlatformEnums.TBR
) => {
  return `linear-gradient(to right, ${
    ThemeGradientColorMap[platform] && ThemeGradientColorMap[platform][0]
  } , ${
    ThemeGradientColorMap[platform] && ThemeGradientColorMap[platform][1]
  })`;
};
